import { Host, Input, Optional, SkipSelf } from '@angular/core';
import { AbstractControl, ControlContainer } from '@angular/forms';
import { ValueAccessorBase } from './value-accessor-base';

export abstract class FormGroupBase<T> extends ValueAccessorBase<T> {
  /**
   * Implement: insert @Input at formGroupName
   * e.g. @Input() formGroupName: string
   */
  @Input() formGroupName: string;
  public control: AbstractControl;


  protected constructor(
    @Optional() @Host() @SkipSelf()
    protected controlContainer: ControlContainer
  ) { super(); }

  /**
   * Call the function checkInitialControl in the OnInit function
   */
  public checkInitialControl() {
    if (this.controlContainer) {
      if (this.formGroupName) {
        this.control = this.controlContainer.control.get(this.formGroupName);
      }
    }
  }
}
